import { createSlice } from "@reduxjs/toolkit";
import { message } from "antd";
import { getUsersByTenant, inviteUserInTenant } from "./thunks";

const initialState = {
  usersByTenant: {},
  loading: true,
};

const usersSlice = createSlice({
  name: "users",
  initialState,
  reducers: {
    setKeyValue: (state, action) => {
      const { key, value } = action.payload;
      state[key] = value;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(getUsersByTenant.pending, (state) => {
        state.loading = true;
      })
      .addCase(getUsersByTenant.fulfilled, (state, action) => {
        const { data, tenant_id } = action.payload;
        state.usersByTenant[tenant_id] = data;
        state.loading = false;
      })
      .addCase(getUsersByTenant.rejected, (state) => {
        state.loading = false;
      })
      .addCase(inviteUserInTenant.fulfilled, (state, action) => {
        const type = action.meta.arg?.type;

        const { data, message: successMessage } = action.payload;

        if (type === "CHANGE_ROLE") {
          const tenantUsers = state.usersByTenant[data?.tenant_id] || [];
          const userIndex = tenantUsers.findIndex(
            (user) => user.id === data.id
          );
          if (userIndex !== -1) {
            tenantUsers[userIndex] = data;
          }
        } else state.usersByTenant[data?.tenant_id].push(data);

        message.success(successMessage || "Invitation sent successfully");
      });
  },
});

export const { setKeyValue } = usersSlice.actions;

export default usersSlice.reducer;
